export const POST_SETTINGS_FIELDS = [
    'categoryIds',
    'coverImage',
    'heroImage',
    'firstPublishedDate',
    'seoSlug',
    'seoTitle',
    'seoDescription',
    'isFeatured',
    'ownerId',
    'ownerSiteMemberId',
    'excerpt',
    'canonicalUrl',
    'isCommentsDisabled',
    'isPinned',
];
export const POST_RCE_FIELDS = ['title', 'content'];
/**
 * @deprecated
 * use POST_CUSTOM_EXCERPT_MAXLENGTH
*/
export const POST_CUSTOM_EXCERPT_MAX_LENGTH = 140;
/** @public Used by `blog-node` */
export const POST_CUSTOM_EXCERPT_MAXLENGTH = 500;
export const POST_TITLE_MAXLENGTH = 200;
export const POST_EXCERPT_TRUNCATED_WORD_MAX_LENGTH = 30;
export const POST_EXCERPT_MAX_LENGTH = 480;
export const POST_CANONICAL_URL_MAXLENGTH = 320;
export const POST_SEO_TITLE_MAXLENGTH = 200;
export const POST_SEO_DESCRIPTION_MAXLENGTH = 500;
export const POST_SEO_SLUG_MAXLENGTH = 100;
export const POST_SEO_OLD_BLOG_SLUG_MAX_LENGTH = 2000;
export const POST_CATEGORY_MAX_COUNT = 10;
export const POST_CATEGORY_LABEL_MAX_LENGTH = 35;
export const POST_TAG_MAX_COUNT = 30;
export const POST_DRAFT_FIELDS = [...POST_RCE_FIELDS, ...POST_SETTINGS_FIELDS];
export const POST_STATUS = {
    published: 'published',
    unpublished: 'unpublished',
    scheduled: 'scheduled',
    deleted: 'deleted',
    /** @deprecated use "in_review" instead */
    in_moderation: 'in_moderation',
    in_review: 'in_review',
};
//# sourceMappingURL=post.js.map